import {
	hasProperty
} from '@/utils/index'
function addProp(val: any, name: string, state: any): void {
	if(hasProperty(val, name)) {
		state.info[name] = val[name];
	}
}
const nxtele = {
	state: {
		info: {
			id: 0,
			name: '',
			appkey: '',
			ctime: '',
			utime: ''
		}
	},
	mutations: {
		SET_NXTELE: (state: any, val: any) => {
			addProp(val, "id", state);
			addProp(val, "name", state);
			addProp(val, "appkey", state);
			addProp(val, "ctime", state);
			addProp(val, "utime", state);
		}
	},
	actions: {
		storeNxtele({commit}: any, data: any) {
			commit('SET_NXTELE', data);
		}
	}
}
export default nxtele;
